var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.50187 14.1984C3.50219 14.395 3.56031 14.5875 3.66937 14.7512L4.20344 15.5541C4.29467 15.6913 4.41841 15.8039 4.56366 15.8817C4.7089 15.9596 4.87114 16.0003 5.03594 16.0003H6.96438C7.12917 16.0003 7.29141 15.9596 7.43665 15.8817C7.5819 15.8039 7.70564 15.6913 7.79688 15.5541L8.33094 14.7512C8.43995 14.5875 8.49822 14.3952 8.49844 14.1984L8.49969 13H3.50031L3.50187 14.1984ZM0.5 5.5C0.5 6.88656 1.01406 8.15156 1.86125 9.11812C2.3775 9.70718 3.185 10.9378 3.49281 11.9759C3.49406 11.9841 3.495 11.9922 3.49625 12.0003H8.50375C8.505 11.9922 8.50594 11.9844 8.50719 11.9759C8.815 10.9378 9.6225 9.70718 10.1388 9.11812C10.9859 8.15156 11.5 6.88656 11.5 5.5C11.5 2.45656 9.02844 -0.00937887 5.98281 -3.87451e-06C2.795 0.00968363 0.5 2.59281 0.5 5.5ZM6 3C4.62156 3 3.5 4.12156 3.5 5.5C3.5 5.77625 3.27625 6 3 6C2.72375 6 2.5 5.77625 2.5 5.5C2.5 3.57 4.07 2 6 2C6.27625 2 6.5 2.22375 6.5 2.5C6.5 2.77625 6.27625 3 6 3Z",
    fill: "#9FA2B4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFp);
export default __webpack_public_path__ + "static/media/ic_fp.3fcee531.svg";
export { ForwardRef as ReactComponent };